import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handlePageShow = this.handlePageShow.bind(this)
    window.addEventListener("pageshow", this.handlePageShow)
    this.restoreDefaults()
  }

  disconnect() {
    window.removeEventListener("pageshow", this.handlePageShow)
  }

  handlePageShow() {
    this.restoreDefaults()
  }

  restoreDefaults() {
    this.namedFields().forEach((field) => {
      if (field.tagName === "SELECT") {
        this.restoreSelect(field)
        return
      }

      if (field.type === "checkbox" || field.type === "radio") {
        field.checked = field.defaultChecked
        return
      }

      field.value = field.defaultValue
    })
  }

  namedFields() {
    return Array.from(this.element.elements).filter((field) => {
      return field.name && field.type !== "hidden" && field.tagName !== "TRIX-EDITOR"
    })
  }

  restoreSelect(field) {
    const defaultOption = Array.from(field.options).find((option) => option.defaultSelected)
    field.value = defaultOption ? defaultOption.value : field.options[0]?.value
  }
}
